import { useSyncExternalStore } from "react";

/**
 * [ui1006, paczka PROC, projekt 4.2] PAMIĘĆ ODPOWIEDZI ŹRÓDEŁ STARTU „Procedur i bezpieczeństwa” (lista procedur, stan powiadomień,
 * macierz braków, ustawienia): kafle nagłówka, blok „Stan” i miejsca czytają ostatnią odpowiedź bez drugiego odczytu (sufit 4 —
 * 2.5 pkt 10). Osobny plik bez warstwy HTTP i bez komponentów: czyta go rejestr obszarów (przez źródła startu), a rejestr czytają
 * też zapadki tras.
 *
 * [poprawki po przeglądzie 2026-10-07] Pamięć jest KLUCZOWANA KONTEM: strona (`PolitykiPage`) w każdym rysowaniu podaje id
 * zalogowanego (`ustawKontoPamieci`), a odpowiedź zapisana przy innym koncie czyta się jako `null`. Bez tego następne konto
 * w tej samej karcie przeglądarki (wylogowanie nie czyści tej pamięci) widziało do nowego odczytu liczby poprzedniego.
 */
let kontoAktualne = null;
/** Konto, dla którego czyta się pamięć (id użytkownika albo `null`). Samo ustawienie zmiennej — bez powiadamiania słuchaczy. */
export const ustawKontoPamieci = (id) => { kontoAktualne = id == null ? null : String(id); };

const zrobPamiec = () => {
    const sluchacze = new Set();
    let ostatnia = null;
    let konto = null;
    const zapamietaj = (dane) => { ostatnia = dane === undefined ? null : dane; konto = kontoAktualne; sluchacze.forEach((f) => f()); };
    const wyczysc = () => zapamietaj(null);
    const zapisz = (f) => { sluchacze.add(f); return () => sluchacze.delete(f); };
    const czytaj = () => (konto === kontoAktualne ? ostatnia : null);
    const usePamieci = () => useSyncExternalStore(zapisz, czytaj, czytaj);
    return { zapamietaj, wyczysc, uzyj: usePamieci };
};

const pamiecListy = zrobPamiec();
const pamiecAutomatu = zrobPamiec();
const pamiecMacierzy = zrobPamiec();
const pamiecUstawien = zrobPamiec();

/** Ostatnia odpowiedź `GET /polityki` z powłoki (albo `null`, dopóki nie przyszła). */
export const zapamietajListe = pamiecListy.zapamietaj;
export const usePamiecListy = pamiecListy.uzyj;
export const zapamietajAutomat = pamiecAutomatu.zapamietaj;
export const usePamiecAutomatu = pamiecAutomatu.uzyj;
export const zapamietajMacierz = pamiecMacierzy.zapamietaj;
export const usePamiecMacierzy = pamiecMacierzy.uzyj;
export const zapamietajUstawienia = pamiecUstawien.zapamietaj;
export const usePamiecUstawien = pamiecUstawien.uzyj;
export const wyczyscPamieciStartu = () => { pamiecListy.wyczysc(); pamiecAutomatu.wyczysc(); pamiecMacierzy.wyczysc(); pamiecUstawien.wyczysc(); };

/** Pozycje listy procedur z odpowiedzi serwera (tablica albo `{ items }` / `{ pozycje }`). */
export const pozycjeListy = (dane) => {
    if (Array.isArray(dane)) return dane;
    if (dane && Array.isArray(dane.items)) return dane.items;
    if (dane && Array.isArray(dane.pozycje)) return dane.pozycje;
    return [];
};

